import {
    getProviderIdLoading,
    getProviderIdRequest,
    getProviderIdSuccess,
    getProviderIdReject,
} from "../../actions/provider/getId";

export const getProviderId = (formData) => async (dispatch, getState) => {
    dispatch(getProviderIdLoading());
    try {
        const { data } = await getProviderIdRequest(formData, getState);
        dispatch(getProviderIdSuccess(data))
    } catch (error) {
        dispatch(getProviderIdReject(error))
    }
    return Promise.resolve();
};